import { ChartTypes } from '~/modules/SDK/Chart2/ChartTypes'
import { PineJS } from '~/modules/SDK/Chart2/PineJS'
import { SessionType } from '~/modules/SDK/Chart2/SessionType'

/**
 * 取得日線的最高價
 *
 * @param this
 * @param daysBack 期別
 * @param sessionType 交易時段
 * @returns number[]
 */
export function dailyHigh(
  this: ChartTypes.IndicatorThis,
  daysBack: number,
  sessionType: SessionType,
): number[] {
  const high: PineJS.NewVar<number> = this.ohlc.highArray
  high.get(4096)

  const dayHighArray: PineJS.NewVar<number> = this._context.new_var()
  dayHighArray.set(this.intradayHighest(high, sessionType))
  const prevHigh: PineJS.NewVar<number> = this._context.new_var()
  dayHighArray.get(4096)
  prevHigh.get(4096)

  if (this.isSessionLastBar(sessionType)) {
    prevHigh.set(dayHighArray.get(0))
  }

  const dailyHighArray: number[] = []

  for (let i = 0; i < daysBack; i++) {
    if (i === 0) {
      dailyHighArray.push(dayHighArray.get(i))
    } else {
      dailyHighArray.push(prevHigh.get(i))
    }
  }
  return dailyHighArray
}
